<template>
    <LiefengContent :isBack="true" @backClick="backClick">
        <template v-slot:title>用户积分排行榜</template>
        <template v-slot:toolsbarLeft>
            <Input :maxlength="20" v-model.trim="searchData.name" placeholder="姓名" style="width: 150px; margin-right: 10px" />
            <Input :maxlength="20" v-model.trim="searchData.phone" placeholder="手机号" style="width: 150px; margin-right: 10px" />
            <Select v-model="searchModel" style="width: 120px; margin-right: 5px" placeholder="全部等级" clearable>
                <Option :value="item.dictKey" v-for="(item, index) in searchList" :key="index">{{ item.dictValue }}</Option>
            </Select>
            <Button
                type="info"
                @click="
                    () => {
                        getList()
                    }
                "
            >
                查询
            </Button>
        </template>
        <template v-slot:toolsbarRight>
            <Button type="info" @click="append({})">新增业务点</Button>
        </template>
        <template v-slot:contentArea>
            <div class="leftMenu">
                <LiefengTable :talbeColumns="tableColumns" :tableData="menuList" :loading="loading" :fixTable="true" :hidePage="true"></LiefengTable>
            </div>

            <LiefengModal :title="currentFormData.topicId ? '修改业务点' : '新增业务点'" width="30%" height="350px" :value="addModal.status" @input="addModalData" class="export-modal">
                <template v-slot:contentarea>
                    <Form :model="currentFormData" :label-width="120" :rules="validateForm" class="form" ref="form">
                        <FormItem label="业务点名称" prop="topicName">
                            <Input placeholder="请输入名称" v-model.trim="currentFormData.topicName"></Input>
                        </FormItem>
                        <FormItem label="描述" prop="topicDesc">
                            <Input type="textarea" v-model.trim="currentFormData.topicDesc" placeholder="简单描述" maxlength="500"></Input>
                        </FormItem>
                    </Form>
                </template>
                <template #toolsbar>
                    <Button type="info" style="margin-right: 10px" @click="addModalData(false)">取消</Button>
                    <Button type="primary" icon="ios-share-outline" @click="submit">保存</Button>
                </template>
            </LiefengModal>
        </template>
    </LiefengContent>
</template>

<script>
//@route('/test15minmanage')
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
import LiefengModal from "@/components/LiefengModal"
import LiefengUpload from "@/components/LiefengUpload"
export default {
    components: {
        LiefengContent,
        LiefengTable,
        LiefengModal,
        LiefengUpload,
    },
    data() {
        return {
            searchData: {},
            searchList:[],
            searchModel: "",
            page: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            menuList: [{}],
            tableColumns: [
                {
                    title: "姓名",
                    width: 250,
                    key: "topicName",
                    align: "center",
                },
                {
                    title: "手机号",
                    minWidth: 200,
                    key: "timeLimit",
                    align: "center",
                },
                {
                    title: "福利金",
                    minWidth: 200,
                    key: "creatorName",
                    align: "center",
                },
                {
                    title: "等级",
                    minWidth: 200,
                    key: "creatorName",
                    align: "center",
                },
                {
                    title: "可兑换数",
                    minWidth: 200,
                    key: "creatorName",
                    align: "center",
                },
                {
                    title: "已兑换数",
                    minWidth: 200,
                    key: "creatorName",
                    align: "center",
                },
                {
                    title: "最近访问时间",
                    minWidth: 200,
                    key: "creatorName",
                    align: "center",
                },
                {
                    title: "操作",
                    align: "center",
                    width: 200,
                    fixed: "right",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    textAlign: "center",
                                },
                            },
                            [
                                h(
                                    "span",
                                    {
                                        on: {
                                            click: async () => {

                                            },
                                        },
                                        style: {
                                            width: "65px",
                                            marginRight: "10px",
                                            textAlign: "center",
                                            color: "#2d8cf0",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        },
                                    },
                                    "查看" //1001
                                ),
                            ]
                        )
                    },
                },
            ],
            currentFormData: {},
            validateForm: {
                topicName: [{ required: true, message: "请输入业务点名称", trigger: "blur" }],
                topicDesc: [{ required: true, message: "请输入描述", trigger: "blur" }],
            },

            addModal: {
                status: false,
            },
            priceModal: {
                status: false,
            },
            topicId: "",
            type: "add",

            showImage: false,
        }
    },
    methods: {
        backClick() {
            var index = parent.layer.getFrameIndex(window.name)
            if (index) {
                //先得到当前iframe层的索引
                parent.layer.close(index) //再执行关闭
            } else {
                this.$router.push({
                    path: "/mallhomepage"
                })
            }
        },
        //   切换状态
        changeSwitch(val, id) {
            return
            this.$post("", {
                id,
                status: val,
            }).then(res => {
                if (res.code != 200) {
                    this.$Message.error({
                        background: true,
                        content: res.desc,
                    })
                }
            })
        },
        // 奖品设置确定接口
        priceSubmit() {
            this.$refs.priceModal.sumbit()
        },
        addModalData(status) {
            this.addModal.status = status
        },
        priceModalData(status) {
            this.priceModal.status = status
        },

        submit() {
            return
            this.$refs.form.validate(status => {
                if (status) {
                    var cFormData = JSON.parse(JSON.stringify(this.currentFormData))
                    this.$post(
                        "",
                        {
                            ...cFormData,
                        },
                        { "content-type": "application/json" }
                    )
                        .then(res => {
                            this.addModalData(false)
                            if (res.code == 200) {
                                this.$Message.success({
                                    background: true,
                                    content: "保存成功",
                                })
                                this.currentFormData = {}
                                this.getList(this.page)
                            } else {
                                this.$Message.error({
                                    background: true,
                                    content: res.desc,
                                })
                            }
                        })
                        .catch(err => {
                            console.log(err)
                            this.$Message.error({
                                background: true,
                                content: "保存失败，请联系管理员处理",
                            })
                        })
                }
            })
        },

        append(data) {
            this.currentFormData = {
                id: data.id,
                topicName: "",
                topicDesc: "",
            }

            this.addModalData(true)
        },
        deleteData(id) {
            this.$Modal.confirm({
                title: "删除选项",
                content: "删除后无法恢复，是否继续删除？",
                okText: "确认删除",
                cancelText: "取消",
                onOk: () => {
                    return
                    this.$post("", {
                        id,
                    }).then(res => {
                        var that = this
                        if (res && res.code == 200) {
                            this.$Message.success({
                                content: "删除成功",
                                background: true,
                            })
                            that.getList()
                            return
                        }
                    })
                },
            })
        },
        hadlePageSize(obj) {
            this.pageSize = obj.pageSize
            this.page = obj.page
            this.getList()
        },
        getList() {
            this.loading = true
            this.$get("/gateway/api/syscenic/pc/question/listQuestionTopicAll", {
                page: this.page,
                pageSize: this.pageSize,
                name:this.searchData.name,
                phone:this.searchData.phone
            })
                .then(res => {
                    if (res.code == 200 && res.dataList) {
                        this.menuList = res.dataList
                        this.page = res.currentPage
                        this.total = res.maxCount
                    }
                    this.$Message.destroy()
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    this.$Message.destroy()
                    this.$Message.error({
                        background: true,
                        content: "获取数据失败，请联系管理员处理",
                    })
                })
        },
    },
    async created() {
        // this.getList()
    },
}
</script>

<style lang='less'>
/deep/.ivu-form-item-content {
    display: flex !important;
}
.ivu-form-item-label {
    display: flex !important;
}
</style>
